


const GoogleMap = () => {
    return (
        <div className="map-area">
            <div className="maps">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3453.2563555275697!2d82.22763487461827!3d16.975903414529835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3829263fa42dc3%3A0x447a1312d6fc4a77!2sFly%20Masters%20Overseas%20Education%20Consultants!5e1!3m2!1sen!2sin!4v1757652421003!5m2!1sen!2sin"></iframe>
            </div>
        </div>
    );
}
 
export default GoogleMap;